// extracted by mini-css-extract-plugin
export default {"sidebar":"Contacts_sidebar__HQh19"};